import 'selectric';

const handler = ( $ ) => {
	// disable autocomplete
	$( 'form, input, textarea' )
		.attr( 'autocomplete', 'off' )
		.attr( 'spellcheck', 'false' )
		.attr( 'autocorrect', 'off' );

	// responsive frames
	$( '#content iframe' )
		.not( '.gform_wrapper + iframe' )
		.not( '.gform_wrapper > iframe' )
		.each( function () {
			const $iframe = $( this );

			if ( ! $iframe.parent().hasClass( 'embed-container' ) ) {
				$iframe.wrap( '<div class="embed-container"></div>' );
			}
		} );

	// responsive tables
	$( 'table' ).wrap( '<div class="responsive-table"></div>' );

	// switch toggles control
	$( document ).on( 'click', '.toggle-control .switch', function () {
		$( this ).next( 'label' ).trigger( 'click' );
	} );

	// custom dropdowns
	$( '.selectric' ).selectric( {
		maxHeight: 620,
		disableOnMobile: false,
		nativeOnMobile: false,
	} );

	// share links: copy to clipboard
	function copyToClipboard( text ) {
		const input = document.createElement( 'input' );
		input.setAttribute( 'value', text );
		document.body.appendChild( input );
		input.select();
		const result = document.execCommand( 'copy' );
		document.body.removeChild( input );
		return result;
	}

	$( '.share-links .share-copy-url' ).on( 'click', function ( e ) {
		e.preventDefault();

		const $link = $( this ),
			url = $link.attr( 'href' );

		copyToClipboard( url );
		$link.addClass( 'is-done' );

		setTimeout( function () {
			$link.removeClass( 'is-done' );
		}, 500 );
	} );

	$( document ).on( 'click', function ( e ) {
		if ( $( e.target ).closest( '.share-links a' ).length === 0 ) {
			$( '.share-links .share-copy-url' ).removeClass( 'is-done' );
		}
	} );

	// download multiple files
	let downloadInterval;

	const downloadFile = function(urls) {
		var url = urls.pop();
	
		var a = document.createElement("a");
		a.setAttribute('href', url);
		/*a.setAttribute('download', '');*/
		a.setAttribute('target', '_blank');
		a.click();
	
		if (urls.length == 0) {
			clearInterval(downloadInterval);
		}
	}

	$('.multiple-files-download').on( 'click', function( e ) {
		e.preventDefault();

		const $link = $(this),
		files = $link.data('files');

		downloadInterval = setInterval(downloadFile, 400, files);

	});

};

export default ( ( $ ) => $( handler ) )( jQuery );
